var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-system-bar',{staticClass:"justify-center darktext--text font-weight-bold",class:_vm.mobile() ? 'text-caption' : 'text-body-2',attrs:{"app":"","height":"36px","color":"anchor20opacity"}},[_vm._v(" "+_vm._s(_vm.$tc('trialExpirationBanner', _vm.trialExpirationDays, { numberDays: _vm.trialExpirationDays }))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }